import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ActiveOrderModel, T4TurboOrderService, AuthService} from 't4core';
import { DialogService } from '../../../../t4common';
import { NewOrderDialog } from '../neworder/neworder';
import * as moment from 'moment';
import { TerminationDialog } from '../TerminationDialog/TerminationDialog';
import { OrderService } from '../../Services/order.service';
import { RepurchaseStatus } from '../../../../../projects/t4core/src/public-api';
import { ChecklistRepurchaseDialog } from '../ChecklistRepurchaseDialog/ChecklistRepurchaseDialog';
import { ChecklistSoldDialog } from '../ChecklistSoldDialog/ChecklistSoldDialog';
import { ChecklistTerminationDialog } from '../ChecklistTerminationDialog/ChecklistTerminationDialog';

@Component({
  selector: 't4-ContractDialog',
  templateUrl: 'ContractDialog.html',
})
export class ContractDialog extends DialogBase implements OnInit {
    public contract: ActiveOrderModel;
    public vehicleId: string;
    public activeContracts: ActiveOrderModel[];
    public vehicle: any;
    public vehicleEvents: any[];
    public forceRepurchased: boolean = false;
    public changes: boolean = false;
 
  constructor(public dialogRef: MatDialogRef<ContractDialog>, @Inject(MAT_DIALOG_DATA) public data: any, private dialogSvc: DialogService, public orderService: T4TurboOrderService, private orderIntegrationService: OrderService, private authService: AuthService) {
        super("ContractDialog");

      if (!data.vehicleId && !data.contractId) {
            alert("Contract is missing");
            dialogRef.close();
    } else if (data.vehicleId) {
      this.vehicleId = data.vehicleId;
      this.loadContracts();
    } else if (data.contractId) {
      this.loadContracts(data.contractId);
    }     
    }

  ngOnInit(): void {
    }

    //ngAfterViewInit() {
    //    (document.querySelector('.turboContainer') as HTMLElement).style.height = '350px';
    //}

    private async loadContracts(contractId: number = 0) {
      this.loading.isLoading = true;
      if (this.vehicleId) {
        this.vehicle = await this.Api.get<any>("/TurboOrder/GetVehicleInfo", { vehicleId: this.vehicleId });
        this.vehicleEvents = await this.Api.get<any>("/TurboOrder/GetNotes", { vehicleId: this.vehicleId, oldMessage: this.vehicle.Comment ? this.vehicle.Comment : null });
        this.activeContracts = await this.Api.get<ActiveOrderModel[]>("/TurboOrder/GetActiveContracts", { vehicleId: this.vehicleId });
      } else {
        this.activeContracts = [await this.Api.get<ActiveOrderModel>("/TurboOrder/GetActiveContractInfo", { contractId: contractId }) ];
      }

        for (let contr of this.activeContracts) {
            if (contr.ForceRepurchase)
            this.forceRepurchased = true;
        }

        this.contract = this.activeContracts[0];
        this.loading.isLoading = false;
    }

  public async forceRepurchase() {
    if (!this.vehicleId) return;
    var confirm = await this.UI.confirm("TO.ActiveContracts.ContractDialog_ConfirmRepurchase.Headline", "Confirm", "TO.ActiveContracts.ContractDialog_ConfirmRepurchase", "Are you sure you want to repurchase this trailer?");

    if (confirm) {
      var validate = await this.Api.put<RepurchaseStatus>("/TurboOrder/ForceRepurchase", null, { vehicleId: this.vehicleId });
      if (validate == RepurchaseStatus.Repurchased) {
        this.UI.alert("Turbo.Core.BookingLink.BookingConfirmed.Headline", "Success!", "TO.ActiveContracts.ContractDialog_RepurchaseSuccess", "Repurchase has been scheduled.");
      } else
        if (validate == RepurchaseStatus.NoContracts) {
          this.UI.alert("Turbo.Core.BookingLink.resendEmailFailed.Headline", "Failed!", "TO.ActiveContracts.ContractDialog_RepurchaseNoContracts", "No contracts available for repurchase");
        }
        else if (validate == RepurchaseStatus.TermiantedAsAnInsuranceCase) {
        this.UI.alert("Turbo.Core.BookingLink.resendEmailFailed.Headline", "Failed!", "TO.ActiveContracts.ContractDialog_RepurchaseFailed", "This trailer is terminated as an insurance case");
        this.vehicle.IsRepurhased = true;
      }
    }
  }

    public static async open(dialog: MatDialog, vehicleId: string) {
      var dlg = dialog.open(ContractDialog, {
        maxHeight: "calc(100vh - 20px)",
        maxWidth: "calc(100vw - 20px)",
        width: "750px",
        data: {
          vehicleId: vehicleId
        }
        });
  }

  public static async openContract(dialog: MatDialog, contractId: number) {
      var dlg = dialog.open(ContractDialog, {
        maxHeight: "calc(100vh - 20px)",
        maxWidth: "calc(100vw - 20px)",
        width: "750px",
        data: {
          contractId: contractId
        }
        });
    }


  public async send2T4(contractId: number) {
    this.orderIntegrationService.SendObject2T4(contractId);
    }

    public async addNote() {
      if (!this.vehicleId) return;
        var note = await this.UI.prompt("turbo.core.dialogs.CreateService.promptNoteHeadline", "Create note", "TO.ActiveContracts.promptNoteQuery", "Add your note here.");

        if (note) {

            var noteCreated = await this.Api.get<boolean>("TurboOrder/CreateNote", { vehicleId: this.vehicle.Id, message: note, oldMessage: this.vehicle.Comment ? this.vehicle.Comment : null });

            if (noteCreated) {
                this.UI.alert("TO.ActiveContracts.headNoteCreated", "Note created!", "TO.ActiveContracts.msgNoteCreated", "The note has been added to this vehicle.");
                this.vehicleEvents = await this.Api.get<any>("/TurboOrder/GetNotes", { vehicleId: this.vehicleId });
                this.changes = true;
            }
            else {
                this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
            }
        }

    }

  public async removeNote(noteId, isNotDeleted = true) {
    if (!this.vehicleId) return;
        if (isNotDeleted) {
            var deleted = await this.Api.get<boolean>("TurboOrder/DeleteNote", { vehicleId: this.vehicle.Id, noteId: noteId });
            if (deleted) {
                this.UI.alert("TO.ActiveContracts.headNoteDeleted", "Note removed!", "TO.ActiveContracts.msgNoteDeleted", "The note has been removed.");
                this.vehicleEvents = await this.Api.get<any>("/TurboOrder/GetNotes", { vehicleId: this.vehicleId });
                this.changes = true;
            }
            else {
                this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
            }
        }
    }

  public async moveVehicle() {
    if (!this.vehicleId) return;
        this.openNewOrderDialog();
  }

    public async scrapVehicle() {
        if (!this.vehicleId) return;
        var note = await this.UI.prompt("turbo.core.dialogs.CreateService.promptScrapNoteHeadline", "Scrap note", "TO.ActiveContracts.promptNoteQuery", "Add your note here.");

        if (note) {

            var result = await this.Api.get<boolean>("TurboOrder/ScrapVehicle", { vehicleId: this.vehicle.Id, message: note });

            if (result) {
                this.UI.alert("TO.ActiveContracts.headNoteScrapped", "Vehicle is scrapped!", "TO.ActiveContracts.msgScrapNoteCreated", "The vehicle has been scrapped.");
                this.vehicleEvents = await this.Api.get<any>("/TurboOrder/GetNotes", { vehicleId: this.vehicleId });
                this.vehicle = await this.Api.get<any>("/TurboOrder/GetVehicleInfo", { vehicleId: this.vehicleId });
                this.changes = true;
            }
            else {
                this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
            }
        }

    }

    public async MoveScraptoInStore() {
        if (!this.vehicleId) return;
        var result = await this.Api.get<boolean>("TurboOrder/MoveScraptoInStore", { vehicleId: this.vehicle.Id});
        if (result) {
            this.UI.alert("TO.ActiveContracts.headNoteMovedScrapToStore", "Vehicle moved!", "TO.ActiveContracts.msgNoteScrapToStore", "The vehicle has been moved from scrapped to store.");
            this.vehicle = await this.Api.get<any>("/TurboOrder/GetVehicleInfo", { vehicleId: this.vehicleId });
            this.changes = true;
        }
        else {
            this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
        }
    }

    public async MoveSoldtoInStore() {
        if (!this.vehicleId) return;
        var result = await this.Api.get<boolean>("TurboOrder/MoveSoldtoInStore", { vehicleId: this.vehicle.Id });
        if (result) {
            this.UI.alert("TO.ActiveContracts.headNoteMovedMoveSoldtoInStore", "Vehicle moved!", "TO.ActiveContracts.msgNoteMoveSoldtoInStore", "The vehicle has been moved from sold to store.");
            this.vehicle = await this.Api.get<any>("/TurboOrder/GetVehicleInfo", { vehicleId: this.vehicleId });
            this.changes = true;
        }
        else {
            this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgNoteFailed", "Something went wrong. Please try again.");
        }
    }


  public async openNewOrderDialog() {
    if (!this.vehicleId) return;
        const dialogref = this.Dialog.open(NewOrderDialog, {
            data: {
                hidePricelist: true,
                requireExisting: true
            }
        });
        var result = await dialogref.afterClosed().toPromise();

        if (result.isValid) {
            var moveVehicleResult = await this.Api.get<boolean>("TurboOrder/MoveVehicle", { vehicleId: this.vehicleId, customerId: result.selectedCustomerId, positionDate: moment().toISOString() });

            if (moveVehicleResult) {
                this.UI.alert("TO.ActiveContracts.headVehicleMoved", "Success!", "TO.ActiveContracts.msgVehicleMoved", "The vehicle has been moved to {0}.", null, [result.selectedCustomer.Name]);
                this.changes = true;
            }
            else {
                this.UI.alert("TO.ActiveContracts.headNoteFailed", "Failed!", "TO.ActiveContracts.msgVehicleMovedFailed", "Something went wrong. Please try again.");
            }
        }
  }

  public async RemovePurchase() {
    if (!this.vehicleId) return;
    await this.orderService.RemovePurchase(this.vehicle.Id);
    this.vehicle.IsRepurchased = false;
  }

  public async RemoveSale() {
    if (!this.vehicleId) return;
    await this.orderService.RemoveSale(this.vehicle.Id);
    this.vehicle.IsSold = false;
  }

  public async ChangeType() {
    if (!this.vehicleId) return;

    var ret = await this.UI.prompt("TO.ActiveContracts.headChangeType", "Change article number", "TO.ActiveContracts.queryChangeType", "Enter the new article number", null, null, this.vehicle.ItemId);

    await this.orderService.SetVehicleType(this.vehicle.Id, ret);
    this.vehicle.OverrideItemId = ret;
  }

  public async impersonate(xalAccountNo: string) {
    if (!this.contract) return;
    var ret = await this.UI.confirm("TO.ActiveContracts.promptComfirmImpersonate", "Confirm impersonate customer", "Turbo.LocationInfo.promptComfirmImpersonateMsg", "Do you want to impersonate the location - {0}?", null, [this.contract.CustomerName]);
    if (ret) {
      this.authService.impersonate(xalAccountNo + "_Admin").then(x => {
      });
    }
    else return;
  }

  public openWhyNotRepurchased() {
    ChecklistRepurchaseDialog.open(this.Dialog, this.vehicle.Id);
  }
  public openWhyNotSold() {
    ChecklistSoldDialog.open(this.Dialog, this.vehicle.Id);
  }
  public openWhyNotTerminated(contractId: number) {
    ChecklistTerminationDialog.open(this.Dialog, contractId);
  }
}
